const burger = document.getElementById('luxBurger');
const nav = document.getElementById('luxNav');

if (burger && nav) {

  burger.addEventListener('click', () => {

    burger.classList.toggle('active');
    nav.classList.toggle('active');

    /* LOCK BODY */

    if(nav.classList.contains('active')){

      document.body.style.overflow = 'hidden';

    }else{

      document.body.style.overflow = '';

    }

  });

  /* CLOSE MENU CLICKING OUTSIDE */

  document.addEventListener('click', (e) => {

    const clickedInsideMenu = nav.contains(e.target);
    const clickedBurger = burger.contains(e.target);

    if(
      nav.classList.contains('active') &&
      !clickedInsideMenu &&
      !clickedBurger
    ){

      nav.classList.remove('active');
      burger.classList.remove('active');

      document.body.style.overflow = '';

    }

  });

}

/* =========================
   SEARCH
========================= */

const searchToggle = document.getElementById('luxSearchToggle');

const searchDrawer = document.getElementById('luxSearch');

const searchClose = document.getElementById('luxSearchClose');

const searchInput = document.querySelector('.lux-search-input');

const searchProducts = document.querySelector('.lux-search-products');

/* OPEN */

if (searchToggle && searchDrawer) {

  searchToggle.addEventListener('click', () => {

    searchDrawer.classList.add('active');

    document.body.style.overflow = 'hidden';

    if(searchInput){
      setTimeout(() => {
        searchInput.focus();
      }, 150);
    }

  });

}

/* CLOSE */

if (searchClose && searchDrawer) {

  searchClose.addEventListener('click', () => {

    searchDrawer.classList.remove('active');

    document.body.style.overflow = '';

  });

}

/* LIVE SEARCH */

if(searchInput && searchProducts){

  searchInput.addEventListener('input', async () => {

    const query = searchInput.value.trim();

    /* EMPTY */

    if(query.length < 1){

      searchProducts.innerHTML = '';

      return;

    }

    try{

      const response = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`
      );

      const data = await response.json();

      const products =
        data.resources.results.products;

      /* EMPTY RESULTS */

      if(products.length === 0){

        searchProducts.innerHTML = `
          <div class="lux-search-empty">
            No se encontraron productos
          </div>
        `;

        return;

      }

      /* RENDER */

      searchProducts.innerHTML = products.map(product => {

        return `

          <a
            href="${product.url}"
            class="lux-search-product"
          >

            <div class="lux-search-product-image">

              <img
                src="${product.featured_image.url}"
                alt="${product.title}"
              >

            </div>

            <div class="lux-search-product-info">

              <div class="lux-search-product-title">
                ${product.title}
              </div>

              <div class="lux-search-product-price">
                ${product.price}
              </div>

            </div>

          </a>

        `;

      }).join('');

    }catch(error){

      console.error(
        'Search error:',
        error
      );

    }

  });

}

/* CLOSE SEARCH CLICKING OUTSIDE */

document.addEventListener('click', (e) => {

  if(!searchDrawer) return;

  const clickedInsideSearch =
    searchDrawer.contains(e.target);

  const clickedSearchButton =
    searchToggle.contains(e.target);

  if(
    searchDrawer.classList.contains('active') &&
    !clickedInsideSearch &&
    !clickedSearchButton
  ){

    searchDrawer.classList.remove('active');

    document.body.style.overflow = '';

  }

});

/* CLOSE SEARCH WITH ESC */

window.addEventListener('keydown', (e) => {

  if(
    e.key === 'Escape' &&
    searchDrawer &&
    searchDrawer.classList.contains('active')
  ){

    searchDrawer.classList.remove('active');

    document.body.style.overflow = '';

  }

});

/* CLOSE SEARCH CLICKING OUTSIDE */

document.addEventListener('click', (e) => {

  if(!searchDrawer) return;

  const clickedInsideSearch = searchDrawer.contains(e.target);
  const clickedSearchButton = searchToggle.contains(e.target);

  if(
    searchDrawer.classList.contains('active') &&
    !clickedInsideSearch &&
    !clickedSearchButton
  ){

    searchDrawer.classList.remove('active');

    document.body.style.overflow = '';

  }

});

/* CLOSE SEARCH WITH ESC */

window.addEventListener('keydown', (e) => {

  if(
    e.key === 'Escape' &&
    searchDrawer &&
    searchDrawer.classList.contains('active')
  ){

    searchDrawer.classList.remove('active');

    document.body.style.overflow = '';

  }

});

/* =========================
   MOBILE CATEGORY ACTIVE
========================= */

if(window.innerWidth < 900){

  const categoryCards = document.querySelectorAll('.category-card');

  const observer = new IntersectionObserver((entries)=>{

    entries.forEach((entry)=>{

      if(entry.isIntersecting){

        categoryCards.forEach((card)=>{
          card.classList.remove('active-mobile');
        });

        entry.target.classList.add('active-mobile');

      }

    });

  },{

    threshold:.75,

    rootMargin:"-10% 0px -10% 0px"

  });

  categoryCards.forEach((card)=>{
    observer.observe(card);
  });

}

/* =========================
   ABOUT STATS COUNTER
========================= */

const statNumbers = document.querySelectorAll('.about-stat-number');

const statObserver = new IntersectionObserver((entries)=>{

  entries.forEach((entry)=>{

    if(entry.isIntersecting){

      const counter = entry.target;

      const target = +counter.dataset.target;

      let current = 0;

      const increment = target / 250;

      const updateCounter = ()=>{

        current += increment;

        if(current < target){

          if(target >= 1000){

            counter.innerText =
              Math.floor(current).toLocaleString() + '+';

          }else{

            counter.innerText =
              Math.floor(current) + '+';

          }

          requestAnimationFrame(updateCounter);

        }else{

          if(target >= 1000){

            counter.innerText =
              target.toLocaleString() + '+';

          }else if(target >= 10){

            counter.innerText =
              target + '+';

          }else{

            counter.innerText =
              target;

          }

        }

      };

      updateCounter();

      statObserver.unobserve(counter);

    }

  });

},{
  threshold:.4
});

statNumbers.forEach((counter)=>{
  statObserver.observe(counter);
});